const account = document.querySelector('shopify-account');

if (account && account.shadowRoot) {

  const coin = account.shadowRoot.querySelector(
    '.account-button--shop-customer .account-button__coin-front'
  );

  if (coin) {
    coin.style.setProperty(
      'background-color',
      '#fffefc',
      'important'
    );
  }

  const style = document.createElement('style');

 style.textContent = `
  .account-button--shop-customer .account-button__coin-front::after {
    box-shadow: inset 0 0 0 0.5px #8B4513 !important;
  }
`;

  account.shadowRoot.appendChild(style);
}